import React from "react";
import ManagementContainer from "./ManagementContainer";
import AdminContainer from "./AdminContainer";

const ProspectsContainer = ({ type }) => {
  let Component;

  switch (type) {
    case "gestion":
      Component = ManagementContainer;
      break;

    case "admin":
      Component = AdminContainer;
      break;

    default:
      Component = () => <div>Unknown prospects type</div>;
      break;
  }

  return (
    <div className="p-4">
      <Component />
    </div>
  );
};

export default ProspectsContainer;
